<!-- www.quickepay / Solutions
Edited with WebStorm
Created by maizerg on 2/20/18 at 1:45 PM
<!-->

<template>
    <div class="about">
        <quick-site-bread-crumb title="Business"/>
        <!-- ======= 2.02 Page About Area ====== -->

        <div class="aboutArea animated">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-sm-6">
                        <div class="aboutContent">
                            <div class="aboutCell">
                                <h2>Uma solução <br>focada ao seu negocio.</h2>
                                <div class="aboutTxt">
                                    <p>Comeca ainda hoje a receber pagamentos de qualquer carteira móvel ou banco atraves dos seus clientes
                                        sem muita complicação.</p>
                                    <p>Num mercado onde o desafio da interoperabilidade é um desafio constante, a <b>Quick-e-Pay</b> oferece-lhe
                                        um canal de pagamentos independente de qualquer que seja a sua conta origem.</p>
                                    <p>Para aderir ao <b>Quick-e-Pay</b> é bastante simples, basta se cadastrar online, sem necessidade qualquer
                                        burocracia, comece a utilizar a nossa API para o seu serviço ou vendas. <br>

                                        O <b>Quick-e-Pay</b> é aplicável para quem tem necessidade de fazer vendas a retalho online,
                                    pagamento de serviços e facturação e muito mais.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="aboutImg">
                <img src="../../assets/images/about01.jpg" alt="">
            </div>
        </div>

        <!-- ======= /2.02 Page About Area ====== -->

        <!-- ======= 2.03 Page Service Area ====== -->
        <div class="aboutServiceArea secPdng">
            <div class="container animated">
                <div class="row">
                    <div class="col-md-12">
                        <div class="sectionTitle">
                            <div class="h2">We are commited with our services. <br>We are offering great services for
                                customers.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 col-sm-6">
                        <div class="singleAboutService">
                            <div class="aServiceIcon">
                                <img src="../../assets/images/icon/about-server1.png" alt="">
                            </div>
                            <div class="aServiceContent">
                                <div class="aServiceTitle h4">Domain Service</div>
                                <div class="aServiceTxt">
                                    <p>Typi non habent claritatem <br>insitam; est usus legentis.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="singleAboutService">
                            <div class="aServiceIcon">
                                <img src="../../assets/images/icon/about-server2.png" alt="">
                            </div>
                            <div class="aServiceContent">
                                <div class="aServiceTitle h4">Domain Service</div>
                                <div class="aServiceTxt">
                                    <p>Typi non habent claritatem <br>insitam; est usus legentis.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="singleAboutService">
                            <div class="aServiceIcon">
                                <img src="../../assets/images/icon/about-server3.png" alt="">
                            </div>
                            <div class="aServiceContent">
                                <div class="aServiceTitle h4">Domain Service</div>
                                <div class="aServiceTxt">
                                    <p>Typi non habent claritatem <br>insitam; est usus legentis.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6">
                        <div class="singleAboutService">
                            <div class="aServiceIcon">
                                <img src="../../assets/images/icon/about-server4.png" alt="">
                            </div>
                            <div class="aServiceContent">
                                <div class="aServiceTitle h4">Domain Service</div>
                                <div class="aServiceTxt">
                                    <p>Typi non habent claritatem <br>insitam; est usus legentis.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ======= /2.03 Page Service Area ====== -->

        <!-- ======= 2.04 Page Team Area ====== -->
        <div class="teamArea secPdng animated">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="sectionTitle">
                            <div class="h2">Great team can give you best support. <br>Meet with our awesome team.</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-4 col-sm-6">
                        <div class="singleTeam">
                            <div class="teamImg"><img src="../../assets/images/about-team1.jpg" alt=""></div>
                            <div class="teamContent">
                                <div class="memberName h4">James Martin</div>
                                <span class="position">Web Experts</span>
                                <div class="teamTxt">
                                    <p>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse mol estie
                                        consequat, vel illum.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="singleTeam">
                            <div class="teamImg"><img src="../../assets/images/about-team2.jpg" alt=""></div>
                            <div class="teamContent">
                                <div class="memberName h4">James Martin</div>
                                <span class="position">Web Experts</span>
                                <div class="teamTxt">
                                    <p>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse mol estie
                                        consequat, vel illum.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="singleTeam">
                            <div class="teamImg"><img src="../../assets/images/about-team3.jpg" alt=""></div>
                            <div class="teamContent">
                                <div class="memberName h4">James Martin</div>
                                <span class="position">Web Experts</span>
                                <div class="teamTxt">
                                    <p>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse mol estie
                                        consequat, vel illum.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="singleTeam">
                            <div class="teamImg"><img src="../../assets/images/about-team1.jpg" alt=""></div>
                            <div class="teamContent">
                                <div class="memberName h4">James Martin</div>
                                <span class="position">Web Experts</span>
                                <div class="teamTxt">
                                    <p>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse mol estie
                                        consequat, vel illum.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="singleTeam">
                            <div class="teamImg"><img src="../../assets/images/about-team2.jpg" alt=""></div>
                            <div class="teamContent">
                                <div class="memberName h4">James Martin</div>
                                <span class="position">Web Experts</span>
                                <div class="teamTxt">
                                    <p>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse mol estie
                                        consequat, vel illum.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="singleTeam">
                            <div class="teamImg"><img src="../../assets/images/about-team3.jpg" alt=""></div>
                            <div class="teamContent">
                                <div class="memberName h4">James Martin</div>
                                <span class="position">Web Experts</span>
                                <div class="teamTxt">
                                    <p>Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse mol estie
                                        consequat, vel illum.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ======= /2.04 Page Team Area ====== -->

        <!-- ======= 2.05 Page Newsletters Area ====== -->
        <div class="newsletterArea secPdng animated">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="sectionTitle">
                            <div class="h2">We always give surprise to our customers. <br>Subscribe to our newsletter to
                                get our offers.
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8 col-md-offset-2">
                        <form action="#" class="newsletter">
                            <div class="inputWrep">
                                <input type="email" placeholder="Enter your email address">
                                <input type="submit" value="Subscrbe Now">
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- ======= /2.05 Page Newsletters Area ====== -->
    </div>
</template>

<script>
export default {}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/business/Solutions.vue